/* ILVA — PDP "Add to basket" attention pulse.

   Gives the main add-to-cart button a brief, gentle pulse (2 cycles — the CSS
   animation lives in product.css) at two moments:
     1. once, when the button first scrolls into view
     2. after a variant change, once the picker has rewritten the button state

   Deliberately NOT continuous — a looping animation on a primary CTA reads as
   an error state. Only a class is toggled on the button element; the label is
   never touched (ilva-button-roll.js owns the label markup and reacts to label
   rewrites on its own). The sticky ATC panel and Shopify dynamic-checkout
   buttons are outside the selector and unaffected.

   Skipped entirely under prefers-reduced-motion (belt: here, braces: the CSS
   rule is wrapped in the same media query). */
(function () {
  if (window.__ilvaAtcAttention) return;
  window.__ilvaAtcAttention = true;

  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {
    return;
  }

  var PULSE_CLASS = 'atc-attention-pulse';
  var ANIMATION_NAME = 'ilva-atc-attention';
  // Space pulses out so browsing through variants doesn't strobe the button
  var MIN_INTERVAL = 4000;
  var lastPulse = 0;

  function getButton() {
    return document.querySelector('.product-info__add-button .btn[name="add"]');
  }

  function isQuickAddContext(element) {
    if (!element) return false;
    return !!element.closest('quick-add-modal, [data-quick-add], .quick-add, .quickbuy');
  }

  function pulse(btn) {
    if (!btn || btn.disabled || btn.classList.contains(PULSE_CLASS)) return;

    var now = Date.now();
    if (now - lastPulse < MIN_INTERVAL) return;
    lastPulse = now;

    btn.classList.add(PULSE_CLASS);

    var cleaned = false;
    var clean = function () {
      if (cleaned) return;
      cleaned = true;
      btn.classList.remove(PULSE_CLASS);
    };
    btn.addEventListener('animationend', function (evt) {
      if (evt.animationName === ANIMATION_NAME) clean();
    }, { once: true });
    // Fallback in case the animation never runs (e.g. the button is hidden
    // mid-pulse) so the class can re-trigger later
    setTimeout(clean, 3000);
  }

  function init() {
    var btn = getButton();
    if (!btn) return;

    var hasScrollPulsed = false;
    var intersectionObserver = null;

    function observeButton(button) {
      if (!button || !('IntersectionObserver' in window) || hasScrollPulsed) return;
      if (intersectionObserver) intersectionObserver.disconnect();
      
      intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          hasScrollPulsed = true;
          intersectionObserver.disconnect();
          setTimeout(function () { pulse(getButton()); }, 600);
        }
      }, { threshold: 0.6 });
      intersectionObserver.observe(button);
    }

    observeButton(btn);

    var isConfigurator = !!document.querySelector('product-configurator');

    if (isConfigurator) {
      // Configurator: wait for dynamic content replacement to finish
      document.addEventListener('on:variant:before-replace-element', function (evt) {
        var target = evt.detail && evt.detail.replaceWith;
        if (target && target.matches('[data-dynamic-variant-content$="-add-to-cart"]') && !isQuickAddContext(target)) {
          setTimeout(function () {
            pulse(getButton());
            observeButton(getButton());
          }, 150);
        }
      });
    } else {
      // Standard variant-picker: pulse after variant change, then re-observe
      document.addEventListener('on:variant:change', function (evt) {
        if (isQuickAddContext(evt.target)) return;
        setTimeout(function () {
          pulse(getButton());
          observeButton(getButton());
        }, 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
